import ScrollFunc from './scrollfunc.es6';

export default class Accordion {
    constructor() {
        this.scrollfunc = new ScrollFunc();
        this.triggers = document.querySelectorAll('.js-acc_trigger');
        this.init();
    }

    init() {
        window.addEventListener('load', this.eventBind.bind(this));
        window.addEventListener('resize', this.handleResize.bind(this)); // Resizeイベントの追加
    }

    resetEvent(reset) {
        this.eventBind(reset);
    }

    eventBind() {
        //アコーディオン
        if (!this.triggers) return;

        this.triggers.forEach((el) => {
            const parent = el.closest('.js-acc');
            const wrapper = el.nextElementSibling;
            const content = wrapper.querySelector('.js-acc_cont');

            //アコーディオンが初期状態で開かれている場合の設定
            if (el.classList.contains('-active')) {
                this.openAccordion(wrapper, content);
            } else {
                wrapper.style.height = '0px'; // 初期状態を閉じた状態に設定
            }

            el.addEventListener('click', () => {
                el.classList.toggle('-active');

                if (getComputedStyle(wrapper).getPropertyValue('height') === '0px') {
                    this.openAccordion(wrapper, content);
                    if (parent) {
                        parent.style.height = `${parent.offsetHeight + content.scrollHeight}px`;
                    }
                } else {
                    this.closeAccordion(wrapper);
                    if (parent) {
                        parent.style.height = `${parent.offsetHeight - content.scrollHeight}px`;
                    }
                }
            });
        });
    }

    handleResize() {
        this.triggers.forEach((el) => {
            const wrapper = el.nextElementSibling;
            const content = wrapper.querySelector('.js-acc_cont');
            if (el.classList.contains('-active')) {
                wrapper.style.height = `${content.scrollHeight}px`;
            } else {
                wrapper.style.height = 0;
            }
        });
    }

    openAccordion(wrapper, content) {
        wrapper.style.height = `${content.scrollHeight}px`;
        setTimeout(() => {
            this.scrollfunc.refreshScroll();
        }, 500);
    }

    closeAccordion(wrapper) {
        wrapper.style.height = 0;
        setTimeout(() => {
            this.scrollfunc.refreshScroll();
        }, 500);
    }
}
